import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer({ className = "" }) {
  const location = useLocation();
  
  const isActive = (path) => {
    // Check if the current path starts with the given path
    // This will match both /ingredient and /ingredients/something
    if (path === '/') {
      return location.pathname === '/';
    }
    
    // Handle both singular and plural forms for ingredients, manufacturers, and tradenames
    if (path === '/ingredients' && (location.pathname.startsWith('/ingredients/') || location.pathname.startsWith('/ingredients/'))) {
      return true;
    }
    if (path === '/manufacturers' && (location.pathname.startsWith('/manufacturers/') || location.pathname.startsWith('/manufacturers/'))) {
      return true;
    }
    if (path === '/tradenames' && (location.pathname.startsWith('/tradenames/') || location.pathname.startsWith('/tradenames/'))) {
      return true;
    }
    
    return location.pathname.startsWith(path);
  };
  
  const footerLinks = [
    { path: "/", label: "Home" },
    { path: "/tradenames", label: "Trade names" },
    { path: "/ingredients", label: "Ingredients" },
    { path: "/manufacturers", label: "Manufacturers" },
    { path: "/terms", label: "Terms & conditions" },
    { path: "/policy", label: "Privacy Policy" },
    { path: "/about", label: "About us" },
    // { path: "/", label: "Reviews" },
  ];

  return (
    <footer className={`pt-6 ${className}`}>

      <div className="container px-6 py-2 mx-auto border-t border-secondary/10">       
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="mb-6 md:mb-0">
            <Link to="/" className="flex items-center max-md:justify-center">
              <img src="/logo.svg" alt="Logo" className="h-4" />
              <span className="ml-2 font-medium text-14 text-secondary">Pharmacy wiki</span>
            </Link>
            <div className="text-12 font-text text-secondary/80">
              © {new Date().getFullYear()} Pharmacy wiki. All rights reserved.
            </div>
          </div>
          
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            {footerLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-12 font-text transition-colors ${
                  isActive(link.path)
                    ? "text-primary font-medium"
                    : "text-secondary/70 hover:text-secondary"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
        
      </div>

       {/* Discliamed terms */}
       <div className="px-6 py-2 mx-auto text-12 font-text text-secondary/80 text-center  mx-auto bg-white/40 backdrop-blur-sm border border-white/60 ">
          
          <p className="max-w-screen-lg mx-auto">
            This site is not a pharmacy and does not sell or promote medicines. 
          All content is for information only—always consult a healthcare professional. Trademarks belong to their owners. 
          Online medicine purchases are made at your own risk.<Link to="/disclaimer" className="text-primary"> [Full disclaimer]</Link>
          </p>
        </div>
    </footer>
  );
}
